/* src/app/candidate/candidate-email/candidate-email.component.scss */
.tr0 {
  top: 7px !important;
  right: 10px !important;
}
.anchor-text {
  color: #2c2c2c !important;
}
.SuccessBoxed {
  width: 100%;
  height: 50px;
  border-radius: 2px;
  border: dashed 1px #2e93a1;
  background-color: #d5e9ec;
  color: #206c79;
}
.wc-form-control-activity {
  width: 280px;
  height: 36px;
  border-radius: 2px;
  border: solid 1px #b3b3b3;
  background-color: #ffffff;
}
.tr-x {
  right: 0;
}
::ng-deep .p-dropdown .p-dropdown-label {
  padding-top: 0 !important;
  margin-top: -15px !important;
}
::ng-deep .p-dropdown-panel .p-dropdown-items .p-dropdown-item {
  padding: 8px !important;
}
::ng-deep .p-inputtext {
  border: none !important;
}
.p-none {
  pointer-events: none;
}
.newcollapsed {
  padding: 2px 12px 5px 12px;
  border-radius: 2px;
  outline: none;
  border: solid 1px rgba(0, 0, 0, 0.1) !important;
}
.collapseBtn i.fa-chevron-down {
  display: none;
}
.collapseBtn i.fa-chevron-up {
  display: flex;
}
.collapseBtn.collapsed i.fa-chevron-down {
  display: flex;
}
.collapseBtn.collapsed i.fa-chevron-up {
  display: none;
}
.collapse-div {
  border: solid 1px rgba(0, 0, 0, 0.1);
  border-top: none;
  background-color: rgb(255, 255, 255);
  z-index: 1012;
}
.text-disabled {
  color: #777777;
  pointer-events: none;
}
.bb-777 {
  border: 1px solid #777777 !important;
}
.wc-checkbox-sm input[type=checkbox i]:disabled {
  border: 1px solid #777777;
}
.wc-checkbox-sm {
  width: 15px;
  height: 15px;
  position: relative;
  left: 0;
  top: 0;
}
.wc-checkbox-sm input[type=checkbox] {
  position: absolute;
  left: 0;
  right: 0;
  width: 14px;
  height: 14px;
}
.wc-checkbox-sm i {
  width: 100%;
  height: 100%;
  background-color: #fff;
  color: #fff;
  border: 1px solid #2e93a1;
  border-radius: 2px;
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.5s;
  font-size: 8px;
}
.wc-checkbox-sm input[type=checkbox]:checked ~ i {
  background-color: #2e93a1;
  border: 1px solid #2e93a1;
  transition: 0.5s;
}
select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  text-indent: 1px;
  text-overflow: "";
}
/*# sourceMappingURL=candidate-email.component-DWMEJZWU.css.map */
